module.exports = __webpack_public_path__ + "img/icon_3_31.b4a28364.png";